import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import device from 'common/support/device';
import { fetchFMS } from 'actions/fms';

import { useUUID } from 'hooks/uuid';
import { useFW } from 'hooks/kitchenSink';

import { UUID_KEY } from 'support/fmsHelper';
import { VideoCtvRedux } from 'store-types';

const fetchFMSParams = (
  reduxDispatch: Dispatch,
  uuid: string,
  isFW: boolean | undefined,
  isKSInitialized: boolean | undefined,
) => {
  if (!isKSInitialized || !isFW) return;

  const ifaPromise = device.getRDID();
  const latPromise = device.getLAT();

  Promise.all([ifaPromise, latPromise]).then(([ifa, lat]) => {
    reduxDispatch(fetchFMS(ifa, lat, uuid));
  });
};

const Fetcher = () => {
  const dispatch = useDispatch();
  const uuid = useUUID(UUID_KEY);
  const isFW = useFW();

  const isKSInitialized = useSelector(
    (state: VideoCtvRedux) => state.kitchenSink?.initialized,
  );

  useEffect(() => {
    const listener = () => {
      fetchFMSParams(dispatch, uuid, isFW, isKSInitialized);
    };
    device.setAdvertiserIDListener(listener);
  }, [dispatch, uuid, isFW, isKSInitialized]);

  useEffect(() => {
    fetchFMSParams(dispatch, uuid, isFW, isKSInitialized);
  }, [dispatch, uuid, isFW, isKSInitialized]);

  const ttl = useSelector((state: VideoCtvRedux) => state.fms.data?.fms_id_ttl);
  const fmsParams = useSelector((state: VideoCtvRedux) => state.fms.data?.fms_params);

  useEffect(() => {
    let retryPeriod = 300000;
    if (ttl && fmsParams) {
      retryPeriod = ttl * 1000;
    }

    if (retryPeriod) {
      const interval = setInterval(() => {
        fetchFMSParams(dispatch, uuid, isFW, isKSInitialized);
      }, retryPeriod);
      return () => {
        clearInterval(interval);
      };
    }

    return undefined;
  }, [ttl, dispatch, uuid, isFW, isKSInitialized, fmsParams]);

  return null;
};

export default Fetcher;
